import * as React from 'react';
import OnboardHeader from 'src/components/agency-onboard/onboard-header/onboard-header';
import OnboardTasksContainer from 'src/components/agency-onboard/onboard-tasks-container/tasks-container';
import {ImplementationManager} from 'src/components/agency-onboard/implementation-manager/implementation-manager';

import css from './onboard-page.css';


export default function OnboardPage() {
  return (
    <div className={css.onboardPageContainer}>
      <OnboardHeader />
      <OnboardTasksContainer />
      <ImplementationManager />
    </div>
  );
}
